/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */
import jwt_decode from 'jwt-decode';

/**
 * Verify if a given user token is a morphed user.
 * @param userToken the user token
 * @returns whether the user is morphed and return a boolean value.
 */
export function isMorphedUser(userToken: string): boolean {
	if (userToken) {
		try {
			const deToken: any = jwt_decode(userToken);
			return deToken?.provider === 'su';
		} catch (error) {
			console.log('Error parsing token: ', error);
			return false;
		}
	}
	return false;
}
